/* eslint-disable react/jsx-no-undef */
import React from "react";
import { Route, Routes } from "react-router-dom";

import Dashboard from "./dashboard/Dashboard";
import Layout from "../../layout/Layout";
import ContentProvider from "./manageContentProvider/contentProvider/ContentProvider";
import LargeAccount from "./settingConfiguration/LargeAccount";
import AccountStatus from "./manageAccount/accountStatus/AccountStatus";
import ManageDnd from "./settingConfiguration/ManageDnd";
import CreateCpServices from "./manageService/createCpServices/CreateCpServices";
import AuditLog from "./auditLog/AuditLog";
import CustomerCare from "./customerCare/CustomerCare";
import SubscriberReport from "./manageReports/SubsciberReport";
import SubscriberRevenueReport from "./manageReports/SubscriberRevenueReport";
import Moreport from "./manageReports/Moreport";
import DefaultSetting from "./settingConfiguration/DefaultSetting";
import SmsTemplate from "./settingConfiguration/SmsTemplate";
import AddPackage from "./manageService/manmagePackage/addPackage";
import ManageSub from "./customerCare/manageSub/manageSub";
import ManageCountryOperator from "./settingConfiguration/manageCountryOperator";
import ManageOperator from "./settingConfiguration/manageOperator/manageOperator";
import ApiAccessDetails from "./apikey/apiAccessDetails";
import IntegrationDocument from "./document/integrationDocument";
  const index = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/manage-content-provider/content-provider"
          element={<ContentProvider />}
        />
        <Route
          path="/manage-account/account-status"
          element={<AccountStatus />}
        />
         <Route
          path="/setting-&-configuration/add-country/operator"
          element={<ManageCountryOperator />}
        />
        <Route
          path="/setting-&-configuration/add-operator"
          element={<ManageOperator />}
        />
        <Route
          path="/manage-service/create-cp-services"
          element={<CreateCpServices />}
        />
        <Route
          path="/document/integration-document"
          element={<IntegrationDocument />}
        />
        <Route
          path="/setting-&-configuration/large-account"
          element={<LargeAccount />}
        />
        <Route
          path="/setting-&-configuration/manage-dnd(block-subscription)"
          element={<ManageDnd />}
        />
        <Route
          path="/api-key/api-access-detail"
          element={<ApiAccessDetails />}
        />
        <Route
          path="/setting-&-configuration/default-settings"
          element={<DefaultSetting />}
        />
      
       
        <Route
          path="/setting-&-configuration/sms-template"
          element={<SmsTemplate />}
        />

        {/* Audit Log */}
        <Route path="/audit-log/action-log" element={<AuditLog />} />
        {/* Audit Log */}

        {/* Customer Care */}
        <Route
          path="/customer-care/customer-details"
          element={<CustomerCare />}
        />
        {/* Customer Care */}

        {/* Manage Reports */}
        <Route
          path="/manage-reports/subscriber-report"
          element={<SubscriberReport />}
        />
        <Route path="/manage-service/add-package" element={<AddPackage />} />
        <Route path="/customer-care/customer-details/sub" element={<ManageSub />} />
          <Route path="/setting-&-configuration/manage-country-operator" element={<ManageCountryOperator />} />
        <Route
          path="/manage-reports/subscriber-revenue-report"
          element={<SubscriberRevenueReport />}
        />
        <Route path="/manage-reports/mo-report" element={<Moreport />} />

        {/* Manage Reports */}

        <Route path="*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
};

export default index;
